import { motion, AnimatePresence } from 'motion/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';

import { ChatMessageStyles } from './ChatMessage.styles';

// Function to parse text with italic formatting (*text*)
const parseItalicText = (text: string): React.ReactNode[] => {
  const parts = text.split(/(\*[^*]+\*)/g);

  return parts.map((part, index) => {
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
      // Remove asterisks and make italic
      const italicText = part.slice(1, -1);
      return (
        <em key={index} style={{ fontStyle: 'italic' }}>
          {italicText}
        </em>
      );
    }
    return part;
  });
};

interface ChatMessageProps {
  content: string;
  variant: 'sent' | 'received';
  show?: boolean;
  delay?: number;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({
  content,
  variant,
  show = true,
  delay = 0,
}) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 100, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -50, scale: 0.9 }}
          transition={{
            duration: 0.3,
            delay,
            ease: [0.25, 0.46, 0.45, 0.94],
          }}
        >
          <ChatMessageStyles variant={variant}>
            <UiTypography variant="body-large" component="span">
              {parseItalicText(content)}
            </UiTypography>
          </ChatMessageStyles>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
